function i(t, r) {
  let {
    offsetWidth: e,
    offsetHeight: n
  } = t;
  if (r) {
    const o = getComputedStyle(t);
    e = e - parseFloat(o.getPropertyValue("padding-left")) - parseFloat(o.getPropertyValue("padding-right")), n = n - parseFloat(o.getPropertyValue("padding-top")) - parseFloat(o.getPropertyValue("padding-bottom"));
  }
  return {
    width: e,
    height: n
  };
}
function p(t, r, e) {
  return t < r ? r : t > e ? e : t;
}
function a(t) {
  if (t === void 0)
    return 0;
  if (typeof t == "number")
    return t;
  const r = /^((\d+)?\.?\d+?)(ms|s)?$/, e = t.match(r);
  if (e) {
    const [, n, , o = "ms"] = e;
    return Number(n) * (o === "ms" ? 1 : 1e3);
  }
  return 0;
}
export {
  i as calculateSize,
  p as clampValue,
  a as resolveSpeed
};
